module.exports = __webpack_public_path__ + "img/securit.2c3807b7.png";